import config from './config'

export default {
  Auth: {
    userPoolId: config.AWS_COGNITO_USER_POOL_ID,
    userPoolWebClientId: config.AWS_COGNITO_USER_POOL_WEB_CLIENT_ID,
    region: process.env.REACT_APP_AWS_REGION || 'us-west-2',
    oauth: {
      // Domain name
      domain : config.COGNITO_OAUTH_DOMAIN,
      // Authorized scopes
      scope : ['aws.cognito.signin.user.admin'],
      // Callback URL
      redirectSignIn : `https://${config.DEPLOY_HOSTNAME}/`,
      // Sign out URL
      redirectSignOut : `https://${config.DEPLOY_HOSTNAME}/login`,
      // 'code' for Authorization code grant,
      // 'token' for Implicit grant
      responseType: 'code',
    }
  }
}
